import { render } from "./TipoDropdown.vue?vue&type=template&id=5caa6f50"
import script from "./TipoDropdown.vue?vue&type=script&lang=js"
export * from "./TipoDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__